import type { Ref } from "vue";
import LxcError from "~/core/models/LxcError.class";
import type { Firmware } from "~/modules/firmware/models/Firmware.interface";
import type { FirmwareUpdatePayload } from "~/modules/firmware/models/FirmwareUpdatePayload.interface";
import firmwareService from "~/modules/firmware/services/firmware.service";

export function useUpdateFirmwareNameAndDescription({
  businessUnitCode,
}: {
  businessUnitCode?: number;
}) {
  const error: Ref<LxcError | null | undefined> = ref(null);
  const isLoading = ref(false);
  const result: Ref<Firmware | undefined> = ref(undefined);

  async function updateFirmwareNameAndDescription(
    uuid: string,
    firmwareUpdatePayload: FirmwareUpdatePayload,
  ) {
    isLoading.value = true;
    error.value = undefined;

    const response =
      await firmwareService.updateBusinessUnitFirmwareNameAndDescription(
        businessUnitCode,
        uuid,
        firmwareUpdatePayload,
      );

    if (LxcError.check(response)) {
      error.value = response;
    } else {
      result.value = response;
    }

    isLoading.value = false;
  }

  return {
    error,
    isLoading,
    result,
    updateFirmwareNameAndDescription,
  };
}
